var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooManyLeadsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #74cc8a;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.87,37.37l-3.77.07s-.03-.11-.14-.12c-8.12-.98-14.38-7.44-15.38-15.4l.07-3.9C3.72,9.87,10.07,3.48,18.29,2.66c10.91-1.09,20.15,8.15,19.06,19.06-.82,8.24-7.29,14.67-15.48,15.65ZM35.25,20c0-8.42-6.83-15.25-15.25-15.25s-15.25,6.83-15.25,15.25,6.83,15.25,15.25,15.25,15.25-6.83,15.25-15.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.26,25.7c-.37.64-.9,1-1.49,1.59l-6.85-6.82-.02-11.36h2.18s0,10.43,0,10.43l6.17,6.16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooManyLeadsIcon);
export default __webpack_public_path__ + "static/media/too-many-leads-icon.8d343954b903ee5c1bff980f0194ae2f.svg";
export { ForwardRef as ReactComponent };